import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../components/button/back";

const EkskulSatu = () => {
  const { id } = useParams();
  const [ekskul, setEkskul] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchEkskulById = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/ekskul/${id}`
        );
        setEkskul(response.data);
        setLoading(false);
      } catch (err) {
        setError("Gagal memuat data ekskul.");
        setLoading(false);
      }
    };

    fetchEkskulById();
  }, [id]);

  if (loading) return <div className="text-center mt-10">Memuat...</div>;
  if (error) return <div className="text-center text-red-600">{error}</div>;

  const getMediaUrl = (filename) => {
    return `${BASE_URL}api/ekskul/media/${filename}`;
  };

  return (
    <div className="min-h-screen bg-gray-100 py-10">
      <div className="mx-auto max-w-3xl p-5 bg-white shadow-lg rounded-lg">
        <div className="flex justify-center mb-6">
          <h1 className="font-bold text-2xl uppercase text-blue-700">
            Ekstrakurikuler
          </h1>
        </div>

        <h2 className="text-2xl font-bold mb-4">{ekskul?.Judul}</h2>

        {/* Preview Gambar / Video */}
        {ekskul?.Gambar?.filename ? (
          ekskul.Gambar.mimetype?.startsWith("image/") ? (
            <img
              src={getMediaUrl(ekskul.Gambar.filename)}
              alt={ekskul.Judul}
              className="w-full h-64 object-cover mb-4 rounded"
            />
          ) : ekskul.Gambar.mimetype?.startsWith("video/") ? (
            <video
              src={getMediaUrl(ekskul.Gambar.filename)}
              controls
              className="w-full h-64 object-cover mb-4 rounded"
            />
          ) : null
        ) : (
          <div className="text-gray-400 italic mb-4">Tidak ada media.</div>
        )}

        <p className="text-gray-700 whitespace-pre-line">{ekskul?.Deskripsi}</p>
        <p className="text-gray-700 whitespace-pre-line">
          Jadwal: {ekskul?.Jadwal}
        </p>
      </div>

      <div className="flex justify-center my-5">
        <Link to="/ekskul">
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default EkskulSatu;
